import React from 'react'
import './styles.scss'
import { ICommonButtonProps } from './types'
import { Loader } from '../loader'

export const Button = ({
  loading = false,
  disabled = false,
  className,
  children,
  onClick,
  ...props
}: ICommonButtonProps) => {
  const getClasses = () => {
    const classes = []
    if (loading) classes.push('loading')

    if (disabled) classes.push('disabled')

    return classes.join(' ')
  }

  return (
    <button
      style={{
        backgroundColor: props.bgColor || '#6204E5',
        color: props.color || '#ffffff',
        width: props.width ? props.width : props.fullscreen ? '100%' : 200,
        height: props.height ?? 48,
      }}
      className={`commonButton ${getClasses()} ${className ? className : ''}`}
      onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()

        if (!disabled && !loading && onClick) onClick(event)
      }}
      {...props}
    >
      {loading ? <Loader color="#fff" /> : children}
    </button>
  )
}
